module.exports = __webpack_public_path__ + "static/media/dashboard.26efede8.svg";